import { combineReducers } from 'redux'
import fishReducer from './fishReducer'
import eventsReducer from './eventsReducer'
import articlesReducer from './articlesReducer'
import loginReducer from './loginReducer'
import appReducer from './appReducer'
import userReducer from './userReducer'

const rootReducer = combineReducers({
  fish: fishReducer,
  events: eventsReducer,
  articles: articlesReducer,
  login: loginReducer,
  app: appReducer,
  users: userReducer
})

export default rootReducer


// WEBPACK FOOTER //
// ./src/reducers/index.js